import { StoryGenerationRequest } from "@/api/stories-types";

export type StoryFormItemErrors = {
  storyType: string;
  category: string;
  subcategory: string;
  gender: string;
  numberOfPages: string;
  pageSize: string;
  count: string;
  promptName: string;
  promptRevision: string;
  modelName: string;
  imagePromptName: string;
  imagePromptRevision: string;
  configRevision: string;
  useMasterCombination: string; // there is no validation for this field, added to avoid TS error, it will always be an empty string
  masterCombinationName: string;
};

export type StoryFormItemValues = Partial<
  Omit<StoryGenerationRequest, "promptId" | "imagePromptId" | "configId" | "masterCombinationId">
> & {
  promptName?: string;
  promptRevision?: number;
  imagePromptName?: string;
  imagePromptRevision?: number;
  configRevision?: number;
  useMasterCombination?: boolean;
  masterCombinationName?: string;
};

export enum ModelOption {
  "gemini:gemini-3.1-pro-preview" = "gemini:gemini-3.1-pro-preview",
  "openai:o3-mini" = "openai:o3-mini",
  "claude:claude-sonnet-4-6" = "claude:claude-sonnet-4-6",
}
